module.exports = "/_next/static/images/bugs-cd57d2069c457099ea92a560fc117bd8.svg";